import downloadBulkFiles from '../helpers/downloadBulkFiles';
import downloadFile from '../helpers/downloadFile';
import { appUrl } from 'lane-shared/config';
import { useGetAuthToken } from './useGetAuthToken';

export const useDownloadFile = <TBody = any,>() => {
  const getAuthToken = useGetAuthToken();

  const downloadFileFromUrl = async ({ url }: { url: string }) => {
    await downloadFile(`${appUrl}${url}`, getAuthToken);
  };

  const downloadBulkFilesFromUrl = async ({
    url,
    body,
    filename,
  }: {
    url: string;
    body: TBody;
    filename?: string;
  }) => {
    await downloadBulkFiles(`${appUrl}${url}`, body, getAuthToken, filename);
  };

  return { downloadFileFromUrl, downloadBulkFilesFromUrl };
};
